<template>
  <Modal
    v-model="_value"
    width="500"
    title="指定业务跟进"
    @on-visible-change="visibleChange"
    ok-text="修改"
    @on-ok="onOk">
    <Form style="display: inline;">
      <FormItem>
        <label style="display: inline-block; width: 60px;">业务人员</label>
        <Select style="display: inline-block; width: 200px;"
                v-model="selectBusinessUserId">
          <Option v-for="item in businessUsers" :value="item.id" :key="item.realName != null?item.realName:item.nickName != null?item.nickName:item.name">{{item.realName != null?item.realName:item.nickName != null?item.nickName:item.name}}</Option>
        </Select>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'renewalorderchangebusinessusermodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      marketSalesId: 7,
      // 当前车辆信息id
      renewalOrderId: null,
      // 业务员列表
      businessUsers: [],
      selectBusinessUserId: null
    }
  },
  methods: {
    ...mapActions([
    ]),
    formatDate (val) {
      if (val) {
        let d = new Date(val)
        return d.Format('yyyy年MM月dd日 hh:mm:ss')
      } else {
        return '无'
      }
    },
    onOk () {
      this.$Modal.confirm({
        title: '确认修改指定业务跟进',
        content: '<p>确认修改指定业务跟进</p>',
        onOk: () => {
          store.dispatch('RenewalOrderServ_ChangeBusinessUser', {
            params: { id: this.renewalOrderId, userId: this.selectBusinessUserId }
          }).then(() => {
            this.$Message.success('修改成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
          })
        },
        onCancel: () => {

        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.businessUsers = []
        this.selectBusinessUserId = null
        let renewalOrderId = this._initValue
        if (renewalOrderId) {
          this.renewalOrderId = renewalOrderId
          store.dispatch('UserServ_GetAllUsers', {
            params: {},
            urlparams: { roleIds: [7] }
          }).then(() => {
            this.businessUsers = store.getters.get_User_GetAllUsersResult
            store.dispatch('RenewalOrderServ_GetDetail', {
              params: { id: renewalOrderId }
            }).then(() => {
              this.selectBusinessUserId = store.getters.get_RenewalOrder_GetDetailResult.businessUserId
            }).catch(err => {
              this.$Message.error(err)
            })
          }).catch(err => {
            this.$Message.error(err)
          })
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
